var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIcEdit(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M15.9561 5.29059C17.3295 3.54272 19.8644 3.2498 21.6002 4.63841L24.1021 6.6399C25.8164 8.01139 26.1049 10.5083 24.7485 12.2347L12.1154 28.3132C11.6098 28.9567 10.8368 29.3324 10.0185 29.3324H4.29222L2.8648 23.6227C2.66494 22.8233 2.8459 21.9763 3.355 21.3284L15.9561 5.29059ZM19.9343 6.72072C19.3557 6.25785 18.5107 6.3555 18.053 6.93812L16.7094 8.64818L21.4206 12.154L22.6517 10.5871C23.1038 10.0117 23.0077 9.17938 22.4362 8.72222L19.9343 6.72072ZM19.7725 14.2516L15.0613 10.7457L5.45185 22.9759L6.37429 26.6657H10.0185L19.7725 14.2516ZM16.6666 27.999C16.6666 27.2627 17.2635 26.6657 17.9999 26.6657H27.3333C28.0696 26.6657 28.6666 27.2627 28.6666 27.999C28.6666 28.7354 28.0696 29.3324 27.3333 29.3324H17.9999C17.2635 29.3324 16.6666 28.7354 16.6666 27.999Z",
    fill: "black"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcEdit);
export default __webpack_public_path__ + "static/media/ic_edit.b44778b955a7b61037ca46c17115138e.svg";
export { ForwardRef as ReactComponent };